// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"scrolling_wrapper__1diH1","scrolling":"scrolling_scrolling__bR3Xe","item":"scrolling_item__mXftY"};